<template>
    <form class="passy-vite-upload-track-form accent-secondary-dark"
          method="post"
          accept-charset="UTF-8"
          enctype="multipart/form-data"
    >
        <csrf-input />
        <input type="hidden" name="action" :value="action"/>
        <input type="hidden" name="enabled" value="true" />
        <input type="hidden" name="sectionId" :value="sectionId" />

        <div class="grid-container max-w-3xl py-10 md:py-20">
            <div class="fiz-form">
                <div class="w-full text-center">
                    <slot />
                </div>

                <div class="flex flex-wrap">
                    <fieldset class="fiz-form__fieldset w-full">
                        <div class="flex flex-wrap">
                            <div class="fiz-form__field w-full md:w-1/2 text-3xl">
                                👋 Salut {{ currentUser.fullName}} !
                                <small class="underline"><a :href="logoutUrl">C'est pas toi ?</a></small>
                            </div>

                            <div class="fiz-form__field w-full sm:w-1/2">
                                <div class="fiz-form__label">
                                    Trace IGC
                                    <span aria-hidden="true" title="Ce champ est requis">*</span>
                                </div>

                                <file-upload name="fields[igcTrack][]"
                                             v-model="formData.igcTrack"
                                             accept=".igc"
                                             required

                                />
                                <p class="text-xs mt-1 text-slate-600">Format IGC</p>

                                <div v-if="errors.igcTrack"
                                     v-text="errors.igcTrack"
                                     class="fiz-form__field-error"
                                />
                            </div>

                            <div class="fiz-form__field w-full sm:w-1/2">
                                <label class="fiz-form__label">
                                    Parcours
                                    <span aria-hidden="true" title="Ce champ est requis">*</span>
                                </label>

                                <select name="fields[taskType]" id="taskType">
                                    <option v-for="(label, value) in taskTypes"
                                            :value="value"
                                            v-text="label"
                                            :selected="value === formData.taskType"
                                    />
                                </select>

                                <div v-if="errors.taskType"
                                     v-text="errors.taskType"
                                     class="fiz-form__field-error"
                                />
                            </div>

                            <div class="fiz-form__field w-full sm:w-1/2">
                                <label class="fiz-form__label">
                                    Homologation de la voile
                                    <span aria-hidden="true" title="Ce champ est requis">*</span>
                                </label>

                                <select name="fields[wingHomologation]" id="wingHomologation">
                                    <option v-for="(label, value) in wingHomologations"
                                            :value="value"
                                            v-text="label"
                                            :selected="value === formData.wingHomologation"
                                    />
                                </select>

                                <div v-if="errors.wingHomologation"
                                     v-text="errors.wingHomologation"
                                     class="fiz-form__field-error"
                                />
                            </div>
                        </div>
                    </fieldset>

                    <p class="grid-col w-full text-xs text-slate-600 mt-4">Les champs marqués d'un astérisque (*) sont requis.</p>
                    <div class="w-full flex justify-center mt-10 md:mt-20">
                        <button type="submit" class="cta cta--secondary">J'envoie ma trace</button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>

<script setup>
import CsrfInput from "@/vue/CsrfInput.vue";
import FileUpload from "@/vue/FileUpload.vue";

import {reactive} from "vue";

const props = defineProps({
    action: { type: String, required: true },
    initialFormData: { type: Object, default: () => ({})},
    errors: { type: Object, required: false, default: () => ({}) },
    sectionId: { type: String, required: true },
    taskTypes: { type: Object, required: true },
    wingHomologations: { type: Object, required: true },
    currentUser: { type: Object, required: true },
    logoutUrl: { type: String, required: true },
});

const formData = reactive({
    taskType: props.initialFormData.taskType,
    wingHomologation: props.initialFormData.wingHomologation,
    igcTrack: undefined,
});

</script>

<style lang="scss" scoped>
@import "../css/components/topo-lines";
.passy-vite-upload-track-form {
   @extend .topo-lines;
}
</style>
